export default __webpack_public_path__ + "static/media/cara-btn-left.20ed60c6.svg";